<!-- 定义全局变量 -->
<script type="text/javascript">
// ******默认url链接********
//var urlBase="http://192.168.1.21:7072/";   //hardy.liu
// var urlBase="http://hardy.free.idcfengye.com/api";   //hardy.liu
 var urlBase = "http://m.fyzxjyzx.com/api"; //正式

// ******图片链接********
var imgBase="https://www.ahsjxjy.com";

export default
{
  urlBase,
  imgBase
}
</script>



// WEBPACK FOOTER //
// global.vue?047e25f7